export default function durationToMSString(duration = 0): string {
  if (duration < 0.005) duration = 0
  const minutes: number = Math.floor(duration / 60)
  const seconds: number = duration % 60

  if (minutes === 0) return `${seconds.toFixed(1)}s`
  return `${minutes}m ${seconds.toFixed(1)}s`
}
